/**
 * This enum handle user login/registration response
 */
export enum UserLoginRegistrationResponse {
  NO_EXCEPTION = 0,
  GENERIC_ERROR = 100,
  USER_ALREADY_EXISTS = 101,
  USER_ALREADY_ACTIVE = 102,
  USER_LOCKED = 103,
  USER_NOT_FOUND = 104,
  USER_NOT_ACTIVE = 105,
  USER_ACTIVATION_EXPIRED = 106,
  USER_MUST_RESET_PASSWORD = 107,
  USER_TAX_CODE_DUPLICATED = 108,
  USER_WITH_SAME_VAT = 109,

  /**
   * Administrator not approved whose trial period is over, returned by the login
   * endpoint of the auth server
   */
  USER_ADMINISTRATOR_EXPIRED = 110,
}

/**
 * This enum handle user invitation response
 */
export enum UserInvitationResponse {
  NO_EXCEPTION = 0,
  GENERIC_ERROR = 100,
  USER_ALREADY_ASSOCIATED = 101,
  USER_TOKEN_EXPIRED = 102,
  USER_NOT_ACTIVE = 103,
  USER_NOT_REGISTRERED = 104,
  INVITATION_NOT_FOUND = 105,
}

/**
 * This enum handle user invitation operation
 */
export enum InvitationState {
  PENDING = 0,
  ACCEPTED = 1,
  DECLINED = 2,
  DELETED = 3,
}

/**
 * THis enum handle user invitation response
 */
export enum UserSendInvitationResponse {
  NO_EXCEPTION = 0,
  GENERIC_ERROR = 100,
  OK_BUT_DUPLICATED = 101,
  ALL_DUPLICATED = 102,
}

/**
 * This enum handle user reset request password handling
 */
export enum UserRequestResetPasswordResponse {
  NO_EXCEPTION = 0,
  GENERIC_ERROR = 100,
  REQUEST_NOT_FOUND = 101,
  REQUEST_EXPIRED = 102,
}

/**
 * This enum handle the type of flag
 */
export enum ConsentsType {
  GENERAL_TERMS_SERVICE = 1,
  COMMERCIAL_COMMUNICATIONS = 2,
  PERSONALIZING_SERVICES = 3,
}
